export default {
  contracts: {
    activeContracts: '有效合同',
    productsAndHours: '涵盖产品和剩余维保时间',
    supported: '维保中',
    notSupported: '没有维保',
    contact: '联系人',
    dividerText: '涵盖产品和剩余维保时间'
  },
  states: {
    OPEN: '待处理',
    AWAITING_REPLY: '等待回复',
    CLOSED: '已关闭',
    FEEDBACK_REQUIRED: '等待回馈意见',
    onlyRequired: '仅显示必需的操作'
  },
  common: {
    New: '新建',
    Open: '跟进',
    Pending: '等待',
    Closed: '完成',
    create: '建立',
    cancel: '取消',
    goBack: '返回',
    close: '完成',
    goToMain: '返回首页',
    news: '新闻提要',
    moreInfo: '更多信息',
    change: '更改',
    send: '发送',
    description: '问题描述',
    skip: '跳过'
  },
  property: {
    name: '酒店名称',
    allProperties: '所有酒店',
    selectProperty: '选择酒店'
  },
  product: {
    name: '产品名称',
    allProducts: '所有产品',
    selectProduct: '选择产品',
    goBack: '返回',
    noProducts: '没有产品'
  },
  chart: {
    chooseMonth: '选择月份',
    noData: '选定日期没有数据'
  },
  navigation: {
    main: '主页',
    interactions: '服务请求',
    contracts: '合同',
    signOut: '注销'
  },
  tickets: {
    createNewTitle: '创建新服务请求',
    title: '标题',
    noTickets: '当前无服务请求',
    search: '搜索',
    createNew: '建立',
    reopenOrDisagree: '不同意',
    escalation: '上报',
    reason: '原因',
    reopen: '重新打开',
    disagree: '不认可',
    escalate: '上报',
    opinionTitle: '您的意见对我们很重要!',
    opinionBody: '请评价我们的工作人员的表现',
    time: '解决时间',
    qualification: '技术资格',
    communication: '沟通技巧',
    sendFeedback: '发送您的回馈意见',
    leaveFeedback: '留下您的回馈意见',
    close: '完成',
    alreadyHasFeedback: '案子已经有回馈意见',
    feedbackHasBeenSent: '回馈意见已经发送',
    ticketHasBeenReopened: '案子重开',
    ticketHasBeenEscalated: '案子上报',
    comment: '评论',
    keyPlaceholder: '输入留言'
  },
  severity: {
    name: '紧急程度',
    0: '一般',
    1: '高',
    2: '紧急',
    wantToChange: '您想要改变严重程度吗?'
  },
  forms: {
    email: '电子邮件',
    password: '密码',
    confirmPassword: '确认密码',
    passwordsDoNotMatch: '密码不匹配',
    updatePassword: '更新密码',
    askRestore: '要求更新密码',
    remember: '记住帐号',
    restorePassword: '重置密码',
    signIn: '登录',
    required: '要求的',
    invalidEmail: '无效的电子邮件地址'
  },
  transactions: {
    date: '日期',
    type: '类型',
    comment: '评论',
    status: '状态',
    subject: '工作要求',
    name: '交易清单',
    hours: '小时',
    viewTransactions: '查看交易记录',
    types: {
      WORK_REQUEST: '工作要求',
      CONTRACT_ACTIVATION: '合同激活',
      CONTRACT_EXPIRATION: '合同到期',
      MANUAL_ADJUST_ADD: '手动调整 - 添加',
      MANUAL_ADJUST_DEDUCT: '手动调整 - 扣除',
      TRANSFER_PROPERTY: '酒店转移',
      TRANSFER_PRODUCT: '产品转移'
    }
  },
  transactionDetail: {
    name: '交易明细',
    num: '编号',
    insertTime: '创建日期',
    requestorName: '请求者名称',
    subject: '主题',
    status: '状态',
    acceptTime: '接受日期',
    cancelTime: '取消日期',
    hours: '时间',
    hourType: '时间类型',
    workText: '工作描述',
    plannedDate: '计划日期'
  },
  statuses: {
    Approved: '已批准',
    Pending: '等待中',
    Cancelled: '已取消'
  },
  hoursTypes: {
    'Included in contract': '包含在合同中',
    'Installation hours': '安装时间',
    'Preventative visit': '预防性访问',
    Chargeable: '收费'
  },
  errors: {
    unknown: '发生未知错误',
    1000: '错误代码1000',
    1001: '错误代码1001',
    1: '登录名或密码错误',
    2: '此页过期',
    3: '未知酒店',
    4: '未知产品',
    7: '未知动作',
    8: '互动动作已经结束',
    11: '访问冲突',
    12: '不明要求',
    660: '此服务请求目前无法关闭，因为它包含未处理的工作申请。技术支持人员已收到您的关闭请求。谢谢。',
    fileSize: '您上传的文件大小不能超过20MB'
  },
  phrases: {
    noAccount: ['您没有登录账户?', '请联系我们'],
    dnd: ['将文件拖至此处或浏览查询', '将文件拖至此处或浏览查询', '']
  }
}
